import * as types from './types';

const initialState = {
  loading: false,
  recievedResponse: false,
  recievedSuccessfulResponse: false,
  recievedErrorResponse: false,
  currentPosting: '',
  bulkSuccessful: 0,
  bulkError: 0
};

function publishReducer(state = initialState, action) {
  switch (action.type) {
    case types.PUBLISH_POSTING:
      return {
        ...state,
        loading: true,
        recievedResponse: false,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: false
      };

    case types.PUBLISH_POSTING_COMPLETED:
      return {
        ...state,
        loading: false,
        recievedResponse: true,
        recievedSuccessfulResponse: true,
        recievedErrorResponse: false,
        data: action.payload,
        bulkSuccessful: action.payload.successfulPostings || 0,
        bulkError: action.payload.errorPostings || 0
      };
    case types.PUBLISH_POSTING_FAILED:
      return {
        ...state,
        loading: false,
        recievedResponse: true,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: true,
        data: action.payload,
        bulkError: action.meta.body.postingIds.length || 1
      };

    case types.RESET_PUBLISH_POSTING:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
}

export default publishReducer;
